import type TrafficMarketModel from "../TrafficMarketModel";

export const isTrafficMarketModel = (object: unknown): object is TrafficMarketModel => {
    if (typeof object !== "object" || object === null) {
        return false;
    }

    const trafficMarket = object as Partial<TrafficMarketModel>;
    const countries = trafficMarket.countries;
    const shouldCheckCountriesType = Array.isArray(countries) && countries.length > 0;

    const conditions = [
        typeof trafficMarket.metric === "string",
        typeof trafficMarket.thresholdValue === "number",
        shouldCheckCountriesType && countries.every((item: unknown) => typeof item === "number"),
    ];

    return conditions.every(Boolean);
};
